<template>
    <div>
        <input :type="type" :name="name" :min="min" :class="{'error': error, 'success': success}" :disabled="disabled" :value="value" @keyup.enter="$emit('enter')" @input="$emit('input',$event.target.value)" class="form-control" :placeholder="placeholder">
    </div>
</template>

<script>
export default {
  props: {
    placeholder: String,
    type: String,
    value: {
      type: [String, Number],
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    error: {
      type: Boolean,
      required: false
    },
    success: {
      type: Boolean,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    min: {
      type: String,
      required: false
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.error{
  border-color: red !important;
}
.success{
  border-color: #58d858 !important;
}
</style>



// WEBPACK FOOTER //
// regularInput.vue?718a84d2